/**
 * Theme functions file.
 *
 */

// Vendor scripts, bundled in the same order Grunt's uglify used to concatenate
// them. They attach to the global jQuery 2.2.4 that functions.php enqueues
// before this bundle, so they are imported here for their side effects only.
import './bootstrap';
import './vendor/device.min';
import './vendor/owl.carousel';
import './vendor/midnight.jquery';

(function($) {

// Start midnight
  $(document).ready(function(){
    // Change this to the correct selector.
    $('.navbar.fixed').midnight();
  });

  function size_video() {
    jQuery('video, .video-sizeable').each(function(){
      var $video = jQuery(this);
      var $container = $video.parent();
      var video = {
        width: 1202,
        height: 676
      };
      if($video.attr('data-ratio')) {
        var ratio = $video.attr('data-ratio').split(',');
        video.width = parseFloat(ratio[0]);
        video.height = parseFloat(ratio[1]);
      }
      var scaleFactor = Math.max($container.width()/video.width, $container.height()/(video.height));
      var newWidth = video.width*scaleFactor;
      var newHeight = video.height*scaleFactor;

      var offsetX = ($container.width()-newWidth) * 0.5;
      var offsetY = ($container.height()-newHeight) * 0.5;
      $video.css({
        width: newWidth,
        height: newHeight,
        left: offsetX,
        top: offsetY
      });// 14px = height of binary strip

    });
  }

  // Cover-size background YouTube/Vimeo iframes. Unlike <video>, an iframe has
  // no intrinsic aspect ratio, so CSS min-width/height can't make it "cover" —
  // we compute the dimensions from data-ratio on every viewport.
  function size_video_embed() {
    jQuery('.pt-video-embed iframe').each(function(){
      var $iframe = jQuery(this);
      var $container = $iframe.closest('.pt-video-embed');
      var w = 16, h = 9;
      // A small overscan avoids sub-pixel edge gaps (YouTube uses 1.2). Vimeo
      // background embeds are clean and cover exactly, so they pass overscan = 1.
      var overscan = parseFloat($container.attr('data-overscan')) || 1;
      var scaleFactor = Math.max($container.width()/w, $container.height()/h) * overscan;
      var newWidth = w*scaleFactor;
      var newHeight = h*scaleFactor;
      $iframe.css({
        width: newWidth,
        height: newHeight,
        left: ($container.width()-newWidth) * 0.5,
        top: ($container.height()-newHeight) * 0.5
      });
    });
  }
  // Background YouTube header. Two pieces of YouTube chrome can appear even with
  // controls:0 because they render in the CENTRE of the player (the one spot the
  // cover-sizing can't push off-screen and clip):
  //   * the playlist prev/next arrows + "next video" card — caused by loop+playlist,
  //   * the end-screen replay/pause button — shown the instant the player ENDs.
  // We loop NATIVELY via loop+playlist (the master theme's approach): the player
  // loops continuously without a seek/re-buffer, so it never re-shows the centre
  // play->pause feedback at the loop point and never reaches ENDED. (A previous
  // seek-to-start loop re-triggered the ‖ feedback on every cycle.) Any playlist
  // prev/next chrome lives at the iframe's left/right edges, which the cover-sizing
  // pushes outside the container's overflow:hidden. The remaining start-phase chrome
  // (buffering spinner + the initial play->pause animation) is hidden behind an
  // opaque cover overlay that only lifts once playback is steady.
  function init_youtube_bg() {
    var placeholders = document.querySelectorAll('.pt-video-embed--youtube .pt-yt-player');
    if (!placeholders.length) { return; }

    function build() {
      [].forEach.call(placeholders, function(el) {
        if (!el.id) { el.id = 'pt-yt-' + Math.floor(Math.random() * 1e6); }
        var videoId = el.getAttribute('data-video-id');
        if (!videoId) { return; }
        var $wrap = jQuery(el).closest('.pt-video-embed').addClass('is-loading');
        // An OPAQUE cover overlay (on top of the iframe) masks every moment YouTube
        // would paint its centre play/pause feedback ‖ — which controls:0 and CSS
        // cannot remove because it lives inside the cross-origin iframe. The cover is
        // shown (.is-loading) during (a) the initial buffer/start and (b) each loop
        // restart, and lifted once playback is steady. It is kept in the DOM (not
        // removed) so it can be reused on every loop. Inherits the poster if set.
        var cover = document.createElement('div');
        cover.className = 'pt-video-cover';
        if ($wrap[0].style.backgroundImage) {
          cover.style.backgroundImage = $wrap[0].style.backgroundImage;
        }
        $wrap.append(cover);
        var revealTimer;
        function reveal(delay) {
          clearTimeout(revealTimer);
          revealTimer = setTimeout(function() { $wrap.removeClass('is-loading'); }, delay || 0);
        }
        // We DON'T use loop+playlist (a playlist makes YouTube render prev/next
        // chrome). Instead we loop by seeking back to the start just before the end,
        // raising the cover first so the restart's ‖ feedback is never seen.
        function loop_before_end(player) {
          if (player._loopTimer) { clearInterval(player._loopTimer); }
          player._loopTimer = setInterval(function() {
            if (!player || typeof player.getCurrentTime !== 'function') { return; }
            var duration = player.getDuration();
            if (!duration) { return; }
            if (!player._looping && player.getCurrentTime() >= duration - 1.2) {
              player._looping = true;
              clearTimeout(revealTimer);
              $wrap.addClass('is-loading');               // raise cover before the restart
              setTimeout(function() { player.seekTo(0, true); }, 400); // seek once cover is opaque
            } else if (player._looping && player.getCurrentTime() < 1) {
              player._looping = false;                    // restarted; PLAYING will lift the cover
            }
          }, 150);
        }
        // Fallback: never leave the video covered if the API stalls.
        var failsafe = setTimeout(function() { $wrap.removeClass('is-loading'); }, 6000);
        // Let the IFrame API BUILD the iframe with controls:0 baked in (the same
        // approach as the master theme). Attaching to a pre-built iframe does not
        // reliably honour controls:0, which is why the pause button showed.
        new YT.Player(el.id, {
          videoId: videoId,
          playerVars: {
            autoplay: 1,
            mute: 1,
            controls: 0,
            playsinline: 1,
            modestbranding: 1,
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            disablekb: 1,
            fs: 0,
            enablejsapi: 1,
            origin: window.location.origin
            // No loop/playlist: a playlist renders prev/next chrome. We loop via
            // loop_before_end() and mask the restart with the cover instead.
          },
          events: {
            onReady: function(e) { e.target.mute(); e.target.playVideo(); size_video_embed(); },
            onStateChange: function(e) {
              if (e.data === YT.PlayerState.PLAYING) {
                clearTimeout(failsafe);
                size_video_embed();
                loop_before_end(e.target);
                // Lift the cover once playback is steady (covers both the initial
                // start and each loop restart), after the ‖ feedback has faded.
                reveal(1200);
              }
            }
          }
        });
      });
    }

    if (window.YT && window.YT.Player) {
      build();
    } else {
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function() { if (prev) { prev(); } build(); };
      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
      }
    }
  }

  $(document).ready(function () {
    init_youtube_bg();

    //Scroll To
    $(".scroll-to").on('click', function(e) {
      $('html, body').animate({
        scrollTop: $("#main").offset().top
      }, 500);
    });

    //Navigation Menu Slider
    $('.menu-toggle').on('click',function(e){
      e.preventDefault();
      jQuery('body').toggleClass('nav-expanded');
    });
    $('#nav-close').on('click',function(e){
      e.preventDefault();
      $('body').removeClass('nav-expanded');
    });

    $('#nav-layer').on('click', function(e) {
      if ($('body').hasClass('nav-expanded')) {
        e.preventDefault();
        $('body').removeClass('nav-expanded');
      }
    });
/*
    function stickyNav () {
      var noHeader = $("body").hasClass("page-template-template-category");
      var headerPageHeight = $(".full-size-page, .fluid-size").outerHeight();
      var navBar = $(".navbar");
      if (headerPageHeight && ($(window).scrollTop() < headerPageHeight)) {
        navBar.removeClass("bg");
      } else if(noHeader == true) {
        navBar.removeClass("bg");
      } else {
        if($(window).scrollTop() > 0) {
          navBar.addClass('bg');
        } else {
          navBar.removeClass("bg");
        }
      }
    }
    stickyNav();*/

    //Slide Menu
/*    var lastScrollTop = 140, delta = 90;
    function slideNav () {
      /!*start header scroll postion check*!/
      var st = $(this).scrollTop();
      var header = $(".navbar");

      if(Math.abs(lastScrollTop - st) <= delta) {
        return;
      }
      if (st > lastScrollTop && st >= 0){
        header.addClass("bg");
      }
      lastScrollTop = st;
    }*/

    //Owl Carousel
    $(".owl-carousel").owlCarousel({
      navigation : true, // Show next and prev buttons
      slideSpeed : 300,
      paginationSpeed : 400,
      singleItem:true,
      navigationText: ["<span class='owl-prev-inner icon-navigate_before'></span>", "<span class='owl-next-inner icon-navigate_next'></span>"]
    });



    //Video
    var vid = document.getElementById("video");
    var pauseButton = document.querySelector("#video-button");
    var $pauseButton = $(pauseButton);
    $pauseButton.removeClass("is-playing");
    if(!window.device.desktop()) {
      size_video();
    }
    size_video_embed();

    if(vid){
      setTimeout(function() {
        if (vid.paused) {
          $pauseButton.removeClass("is-playing");
        } else {
          $pauseButton.addClass("is-playing");
        }
      }, 600);

      if(pauseButton) {
        vid.addEventListener('ended', function () {
          vid.pause();
          $pauseButton.removeClass("is-playing");
        });

        pauseButton.addEventListener("click", function () {
          if (vid.paused) {
            vid.play();
            if(!device.iphone()) {
              $pauseButton.addClass("is-playing");
            }
          } else {
            vid.pause();
            $pauseButton.removeClass("is-playing");
          }
        });

        vid.addEventListener('webkitendfullscreen', function() {
          if(device.iphone()) {
            if (vid.paused) {
              $pauseButton.removeClass("is-playing");
            } else {
              $pauseButton.addClass("is-playing");
            }
          }
        }, false);
      }
    }

    $(window).on("scroll", function() {
    //  stickyNav();
    //  slideNav();
      if(window.device.desktop()) {
        var scrolled = ($(this).scrollTop() / $(window).height()) * 100;
        $('#video').css('transform', 'translate3d(-50%, ' + (-50 - scrolled * -0.25) + '%, 0)');
      }
    });

    $(window).on('resize', function() {
      if(!window.device.desktop()) {
        size_video();
      }
      size_video_embed();
    });

  });

})(jQuery);
